import styled from 'styled-components/native';

import HandWithPhone from 'svg/HandWithPhone';

export default styled(HandWithPhone)`
  width: 84.4%;
  aspect-ratio: 1;
`;
